/**
 * Application Configuration
 *
 * This file contains application-wide configuration constants used throughout
 * the frontend application.
 */

/**
 * Billing Flow Configuration
 *
 * Constants for the Shopify billing activation flow, including timing for
 * redirects and fallback timeouts for webhook processing.
 */
export const BILLING_FLOW_CONFIG = {
  /**
   * Time to wait before redirecting to dashboard after successful activation
   * @default 3000ms (3 seconds)
   */
  REDIRECT_DELAY_MS: 3000,

  /**
   * Maximum time to wait for webhook activation before redirecting to dashboard
   * User can still access dashboard if subscription is active
   * @default 15000ms (15 seconds)
   */
  WEBHOOK_ACTIVATION_TIMEOUT_MS: 15000,
} as const;

/**
 * Type-safe access to billing flow configuration
 */
export type BillingFlowConfig = typeof BILLING_FLOW_CONFIG;
